module.exports = __webpack_public_path__ + "img/report.34651367.svg";